import buildSlug from './build-slug';
import designAutomation from './design-automation';
import emptyPage from './empty-page';
import metaTranslations from './meta-translations';
import pageContainerSelector from './page-container-selector';
import pageTemplateHTML from './page-template-html';
import pageTemplates from './page-templates';
import socialIcons from './social-icons';
import supportedBlockCategoriesForRegeneration from './supported-block-categories-for-regeneration';
import variables from './variables';

export default {
  buildSlug,
  designAutomation,
  emptyPage,
  metaTranslations,
  pageContainerSelector,
  pageTemplateHTML,
  pageTemplates,
  socialIcons,
  supportedBlockCategoriesForRegeneration,
  variables,
};
